"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// @todo try a more complex type for ComposedComponent + return type
exports.default = function (ComposedComponent) {
  var Focused = function (_Component) {
    _inherits(Focused, _Component);

    function Focused() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Focused);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focused.__proto__ || Object.getPrototypeOf(Focused)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        focused: false
      }, _this.handleFocus = function (event) {
        _this.setState({ focused: true });
        if (typeof _this.props.onFocus === "function") {
          _this.props.onFocus(event);
        }
      }, _this.handleBlur = function (event) {
        _this.setState({ focused: false });
        if (typeof _this.props.onBlur === "function") {
          _this.props.onBlur(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Focused, [{
      key: "render",
      value: function render() {
        return _react2.default.createElement(ComposedComponent, _extends({}, this.props, this.state, {
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }));
      }
    }]);

    return Focused;
  }(_react.Component);

  return Focused;
};